// Расширение → MIME для Blob; неизвестное — application/octet-stream
const MIME_BY_EXT = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  zip: 'application/zip',
  csv: 'text/csv',
}

/**
 * Сохраняет полученный запросом файл на диск пользователя.
 *
 * Для скачиваний через `useApi` (он ставит `Authorization` и `X-Locale`): не-JSON ответ
 * приходит в `model.bytes`, сюда — эти байты. Браузер сохраняет только по ссылке,
 * поэтому временная `<a download>` на Blob; URL освобождаем сразу после клика.
 *
 * @param {Uint8Array|Blob} data содержимое файла
 * @param {string} name имя файла без расширения
 * @param {string} ext расширение без точки (`xlsx`, `pdf`…): дописывается к имени и задаёт MIME
 */
export function saveBlob(data, name, ext) {
  const type = MIME_BY_EXT[ext] ?? 'application/octet-stream'
  const blob = data instanceof Blob ? data : new Blob([data], { type })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `${name}.${ext}`
  a.click()
  URL.revokeObjectURL(url)
}
